import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactService } from './contact/contact.service';
import { DomainService } from './domain/domain.service';
import { DureeService } from './duree/duree.service';
import { FormationService } from './formation/formation.service';
import { ModaliteService } from './modalite/modalite.service';
import { SessionService } from './session/session.service';
import { SiteService } from './site/site.service';
import { UserService } from './user/user.service';
import { MenuStoreService } from './menu-store/menu-store.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    ContactService,
    DomainService,
    DureeService,
    FormationService,
    ModaliteService,
    SessionService,
    SiteService,
    UserService,
    MenuStoreService
  ]
})
export class ServicesModule {}
